import axios from 'axios'

/**
 * Helper function to determine error type and return appropriate message
 * @param error - The error object from a try-catch block
 * @param defaultMessage - The default error message to show if error type cannot be determined
 * @returns A user-friendly error message
 */
export const getErrorMessage = (error: unknown, defaultMessage: string): string => {
	if (axios.isAxiosError(error)) {
		// Network error (no internet, connection refused, etc.)
		if (!error.response) {
			return 'Network error. Please check your internet connection and try again.'
		}
		// Server error (error response from server)
		const status = error.response?.status
		const message = error.response?.data?.message || error.message

		if (status && status >= 500) {
			return 'Server error. Please try again later.'
		}

		return message || defaultMessage
	}

	// Generic error
	return defaultMessage
}
